import { Button, Group, Modal, Stack, TextInput } from '@mantine/core'
import { Typography } from '../common/typography'
import { zodResolver } from 'mantine-form-zod-resolver'
import {
  TwoFactorAuthentication,
  TwoFactorAuthenticationSchema,
  useDisableTwoFactorAuthentication,
} from './api'
import { useForm } from '@mantine/form'
import classes from './Settings.module.css'

export default function DisableTwoFactorAuthentication({
  openedDisableModal,
  closeDisableModal,
}: {
  openedDisableModal: boolean
  closeDisableModal: () => void
}) {
  const {
    mutate: disableTwoFactorAuthentication,
    isPending: isDisableTwoFactorAuthenticationPending,
  } = useDisableTwoFactorAuthentication()

  const disableTwoFactorAuthenticationForm = useForm<TwoFactorAuthentication>({
    initialValues: {
      token: '',
    },
    validate: zodResolver(TwoFactorAuthenticationSchema),
  })

  const handleDisableOtp = (values: TwoFactorAuthentication) => {
    disableTwoFactorAuthentication(values, {
      onSuccess: () => {
        disableTwoFactorAuthenticationForm.reset()
        closeDisableModal()
      },
    })
  }

  return (
    <Modal.Root
      opened={openedDisableModal}
      onClose={closeDisableModal}
      centered
      transitionProps={{
        transition: 'fade',
        duration: 200,
        exitDuration: 150,
        timingFunction: 'ease-out',
      }}
      size="xs"
    >
      <Modal.Overlay backgroundOpacity={0.3} blur={2} />
      <Modal.Content>
        <Modal.Body>
          <form
            onSubmit={disableTwoFactorAuthenticationForm.onSubmit(
              handleDisableOtp
            )}
          >
            <Stack gap="sm">
              <Typography lh="150" ta="center">
                Are you sure you want to disable two factor authentication?
              </Typography>
              <TextInput
                className={classes.inputContainer}
                placeholder="Enter Your OTP Token"
                {...disableTwoFactorAuthenticationForm.getInputProps('token')}
              />
              <Group gap="sm" justify="center">
                <Button className={classes.button} onClick={closeDisableModal}>
                  Cancel
                </Button>
                <Button
                  className={classes.disableButton}
                  type="submit"
                  disabled={
                    disableTwoFactorAuthenticationForm.values.token.trim()
                      .length === 0
                  }
                  loading={isDisableTwoFactorAuthenticationPending}
                >
                  Disable
                </Button>
              </Group>
            </Stack>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
